import { useEffect, useRef } from "react";
import { useConsent } from "../consent/ConsentContext";

export default function PosthogGate() {
  const { consent } = useConsent();
  const initializedRef = useRef(false);
  const phRef = useRef(null);

  useEffect(() => {
    const run = async () => {
      if (consent === null) return;

      const analyticsOn = !!consent.analytics;

      // ✅ AUS: SDK hart in opt-out + config runterdrehen
      if (!analyticsOn) {
        const ph = phRef.current || window.posthog;

        if (ph) {
          try {
            // Autocapture/Pageview sofort deaktivieren
            ph.set_config?.({ autocapture: false, capture_pageview: false });

            // Session recording stoppen (falls aktiv)
            ph.stopSessionRecording?.();

            // Wichtig: erst reset, dann opt-out (sonst opt-out kann verschwinden)
            ph.reset?.(true);
            ph.opt_out_capturing?.();
          } catch {}
        }

        // Referenzen kappen
        phRef.current = null;
        window.posthog = undefined;
        return;
      }

      // ✅ AN: erst jetzt laden
      const key = import.meta.env.VITE_POSTHOG_KEY;
      const host = import.meta.env.VITE_POSTHOG_HOST;
      if (!key || !host) {
        console.warn("[PostHog] Missing env", { key: !!key, host });
        return;
      }

      const mod = await import("posthog-js");
      const posthog = mod.default;

      phRef.current = posthog;
      window.posthog = posthog;

      if (!initializedRef.current) {
        posthog.init(key, {
          api_host: host,
          capture_pageview: false, // du machst pageviews selbst
          autocapture: true,       // nur wenn du Autocapture überhaupt willst
        });
        initializedRef.current = true;
      }

      // opt-in explizit setzen
      posthog.opt_in_capturing?.();
    };

    run();
  }, [consent]);

  return null;
}
